module.exports = __webpack_public_path__ + "media/country_flags/tk-72f35273.png";